// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box_content[data-v-36d57749]{height:100%;overflow-y:scroll;scrollbar-width:none;-ms-overflow-style:none}.box_content_padding[data-v-36d57749]{padding:8px 8px}.box_content[data-v-36d57749]::-webkit-scrollbar{display:none}.platform[data-v-36d57749]{display:block;padding:10px 0;border-radius:3px}.platform[data-v-36d57749]:hover{color:#5cadff;border-color:#5cadff}.platform-actived[data-v-36d57749]{color:#2d8cf0;border-color:#2b85e4}", ""]);
// Exports
module.exports = exports;
